// @flow
export { default } from './ProductPlaceholder';



// WEBPACK FOOTER //
// ./src/components/product/ProductPlaceholder/index.js